import styled from "styled-components";
import { Avatar, Col, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ClassCardBodyProps = {
  "data-stacked": boolean;
};

type GrayableProps = {
  gray?: boolean | number;
  showARibbon?: boolean;
  showDate?: boolean;
};
type ArrowProps = {
  direction: string;
};

export const ClassCardContainer = styled(Col)`
  margin: 8px 0;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;

  &:hover {
    .hoverable-target.fade-bg {
      filter: brightness(110%);
    }
  }
  .follow {
    all: unset;
    background: #1070b6;
    overflow: hidden;
    cursor: pointer;
    width: 100%;
    .follow-header {
      padding-top: 5px;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
      color: #fdd440;
      transform: scaleX(1.15);
      @media screen and (max-width: 848px) and (min-width: 768px) {
        font-size: 15px;
      }
      @media screen and (min-width: 990px) and (max-width: 1139px) {
        font-size: 15px;
      }
    }
    .follow-content {
      display: flex;
      justify-items: center;
      padding: 0 16px;
      .follow-text {
        color: white;
        text-align: left;
        transform: scaleX(1.15);
        transform-origin: left;
        padding-top: 8px;
      }
      .follow-img {
        width: 70%;
      }
      @media screen and (max-width: 848px) and (min-width: 768px) {
        .follow-img {
          width: calc(55% + 8px);
        }
      }
      @media screen and (min-width: 990px) and (max-width: 1139px) {
        .follow-img {
          width: calc(55% + 8px);
        }
      }
      .follow-img {
        width: 70%;
      }
      @media screen and (max-width: 840px) and (min-width: 768px) {
        .follow-img {
          width: calc(55% + 10px);
        }
      }
      @media screen and (min-width: 990px) and (max-width: 1139px) {
        .follow-img {
          width: calc(55% + 10px);
        }
      }
    }
    @media screen and (min-width: 1260px) {
      .follow-content {
        height: 155.5px;
      }
    }
    .follow-content {
      height: 155px;
    }
  }
`;

export const ClassCardBody = styled.div`
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border-radius: 2px;
  width: ${(props: ClassCardBodyProps) =>
    props["data-stacked"] ? "90%" : "100%"};
`;
export const ClassCardBelow = styled.div`
  position: absolute;
  border-radius: 2px;
  width: 100%;
  height: 90%;
  padding-left: 12px;
  padding-right: 12px;
  filter: brightness(80%);
  & .header {
    height: 33px;
    background-color: #fdd440;
  }
  & .body {
    height: calc(100% - 66px);
    background-color: white;
    position: relative;
  }
  & .footer {
    height: 33px;
    background-color: #d3e8ff;
  }
`;

export const ClassCardHeader = styled.div`
  padding: 6px 16px;
  display: flex;
  justify-content: ${({ showARibbon, showDate }) => {
    if (showARibbon) return "flex-start";
    if (showDate) return "space-between";
    return "center";
  }};
  align-items: center;
  background-color: ${({ gray }: GrayableProps) =>
    gray ? "#707070" : "#fdd440"};
  color: ${({ gray }: GrayableProps) => (gray ? "#f6f6f6" : "#1070b6")};
  font-weight: bold;
  font-size: 13.5px;
`;

export const CardDate = styled.time`
  text-align: left;
`;

export const CardTime = styled.time`
  text-align: center;
`;

export const CardContent = styled.div`
  padding: 10px 16px 8px;
  flex-grow: 1;
  background-color: ${({ gray }: GrayableProps) =>
    gray ? "#e4e4e4" : "#ffffff"};
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  flex-grow: 1;
  cursor: pointer;
`;

export const CardDetailsAlignCenter = styled(CardDetails)`
  text-align: center;
`;

export const Topic = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: black;
  margin: 2px 0px 5px;
  height: 47px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  overflow-wrap: break-word;
`;

export const LevelAndChapter = styled.div`
  font-size: 12px;
`;

export const CategoryAndCityAndLanguage = styled.div`
  display: flex;
`;

export const Category = styled.div`
  background-color: ${({ gray }: GrayableProps) =>
    gray ? "#707070" : "#1070b6"};
  color: white;
  font-size: 9px;
  font-weight: 700;
  margin: 0px 5px 5px 0px;
  padding: 1px 5px;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-self: center;
`;

export const City = styled(Category)``;

export const Language = styled(Category)``;

export const ClassTypeAndSeatsRemaining = styled.div`
  margin-top: auto;
  font-size: 12px;
  font-weight: bold;
  color: ${({ gray }: GrayableProps) => (gray ? "#707070" : "#1070b6")};
  padding: 2px 0px;
`;

export const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;

  & .instructor-avatar {
    border: 2px solid transparent;
  }

  &:hover .instructor-avatar {
    border-color: #1070b6;
  }

  &:hover .instructor-name {
    color: #1070b6;
  }
`;

export const InstructorAvatar = styled(Avatar)`
  margin: 0px 0px 8px;
`;

export const InstructorName = styled.span`
  font-size: 12px;
`;

export const StudiedTopic = styled.div`
  font-size: 12px;
  margin-bottom: 5px;
  color: #282828;
`;

export const ClassCardFooterWrapper = styled.div`
  display: flex;
  flex-grow: 0;
  width: 100%;
`;

export const CardFooterButton = styled.div`
  padding: 6px 0px;
  background-color: ${({ gray }: GrayableProps) =>
    gray ? "#b4b4b4" : "#d3e8ff"};
  margin-top: auto;
  color: ${({ gray }: GrayableProps) => (gray ? "#f6f6f6" : "#1070b6")};
  font-weight: bold;
  font-size: 13.5px;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  text-align: center;

  &:hover {
    filter: brightness(90%);
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
  @media screen and (min-width: 1140px) {
    &.follow-button {
      position: absolute;
      left: 12px;
      right: 12px;
    }
  }
`;

export const DownloadAnnotatedButton = styled(Button)`
  padding: 6px 0px;
  background-color: #d3e8ff;
  margin-top: auto;
  color: #1070b6;
  font-weight: bold;
  font-size: 13.5px;
  flex-grow: 1;
  text-align: center;
  border: none;
  border-radius: 0px;

  &:hover {
    background-color: #d3e8ff;
    filter: brightness(90%);
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
`;

export const StackedCardFooterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const CardFooterNavigationArrow = styled(FontAwesomeIcon)`
  flex-grow: 0;
  padding: 0px 10px;
  background-color: ${({ gray }: GrayableProps) =>
    gray ? "#b4b4b4" : "#d3e8ff"};
  text-align: right;
  color: ${({ gray }: GrayableProps) => (gray ? "#f6f6f6" : "#1070b6")};
  display: flex;
  justify-content: center;
  align-items: center;

  &.svg-inline--fa.fa-w-14 {
    width: 33px;
    height: 33px;
  }

  &:hover {
    filter: brightness(90%);
    cursor: pointer;
  }

  &:focus {
    background-color: #d3e8ff;
  }
`;
export const ArrowContainer = styled.div`
  width: fit-content;
  display: flex;
  justify-content: space-between;
  position: absolute;
  padding-left: 12px;
  padding-right: 12px;
  z-index: 2;
  left: ${({ direction }: ArrowProps) => (direction === "left" ? "0" : "")};
  right: ${({ direction }: ArrowProps) => (direction === "right" ? "0" : "")}; ;
`;
export const NavigationArrow = styled(FontAwesomeIcon)`
  flex-grow: 0;
  padding: 0px 10px;
  background-color: #fdd440;
  text-align: right;
  color: #1070b6;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ direction }: ArrowProps) =>
    direction === "left" ? "0 50% 50% 0" : "50% 0 0 50%"};

  &.svg-inline--fa.fa-w-14 {
    width: 33px;
    height: 33px;
  }

  &:hover {
    filter: brightness(90%);
    cursor: pointer;
  }

  &:focus {
    background-color: #d3e8ff;
  }
`;
